import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['select']
  static values = {
    tab: String
  }

  tabValue!: string

  submit (event: Event): void {
    event.preventDefault()

    const form = this.element as HTMLFormElement
    const url = new URL(form.action, window.location.origin)

    const formData = new FormData(form)
    for (const [key, value] of formData.entries()) {
      url.searchParams.set(key, String(value))
    }

    const tab = typeof this.tabValue === 'string' && this.tabValue.trim() !== ''
      ? this.tabValue
      : 'assessment'
    url.searchParams.set('tab', tab)
    url.hash = ''

    window.location.assign(url.toString())
  }
}
